import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              编辑团队为你精选的同人创作深度好文，从角色分析到创作技巧，一网打尽
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {featured.map((article) => (
              <ArticleCard key={article.slug} article={article} variant="default" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}